import React from 'react';
import ReactDOM from 'react-dom'

const TextSpanPortal = ({ portalId, children }) => {
  return ReactDOM.createPortal(
    children, 
    document.getElementById(portalId)
  );
};

export default TextSpanPortal;